import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "./posts";
import "./BlogHome.css"

const BlogHome = () => {
  console.log("Blog posts:", blogPosts.length);

  return (
    <div className="container">
      <h1 className="text-4xl font-bold text-center mb-12">The Futsal Directory Blog</h1>
      <div className="grid-container">
        {blogPosts
          .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort by date (newest first)
          .map((post) => (
            <Link
              to={`/blog/${post.slug}`}
              key={post.slug}
              className="tile"
            >
              <div className="tile-content">
                <h2 className="tile-title">{post.title}</h2>
                <p className="tile-excerpt">{post.excerpt}</p>
              </div>
              <div className="read-more">Read more →</div>
            </Link>
          ))}
      </div>
      <div className="contribute-text">
        <p>Want to contribute to our blog? Get in touch here: <a href="mailto:thefutsaldirectory@gmail.com">
          thefutsaldirectory@gmail.com
        </a></p>
      </div>
    </div>
  );
};

export default BlogHome;
